import React from "react";

function SortedBusinessList({ businessList, offerings }) {
    let businessesSorted = [];
    // businessesSorted.push({ disabled: true, Key: "[BBC]", Display: "[BBC Licenses]" });
    for (var item of businessList) {
        if (item.Status !== "ARCHIVED" && item.Type === "BBC")
            businessesSorted.push({
                Key: item.id,
                Display: item.id + "-" + item.Name,
                POA: item?.Offer?.Regions?.[0],
                State: GetStateFromPOA({ poa: item?.Offer?.Regions?.[0], offerings }),
            });
    }
    // businessesSorted.push({ disabled: true, Key: "[Engineers]", Display: "[Engineers Licenses]" });
    for (var item of businessList) {
        if (item.Status !== "ARCHIVED" && item.Type === "Engineer")
            businessesSorted.push({
                Key: item.id,
                Display: item.id + "-" + item.Name,
                POA: item?.Offer?.Regions?.[0],
                State: GetStateFromPOA({ poa: item?.Offer?.Regions?.[0], offerings }),
            });
    }
    // businessesSorted.push({ disabled: true, Key: "[Customers]", Display: "[Customers Licenses]" });
    for (var item of businessList) {
        if (item.Status !== "ARCHIVED" && (!item.Type || (item.Type !== "Engineer" && item.Type !== "BBC")))
            businessesSorted.push({
                Key: item.id,
                Display: item.id + "-" + item.Name,
                POA: item?.Offer?.Regions?.[0],
                State: GetStateFromPOA({ poa: item?.Offer?.Regions?.[0], offerings }),
            });
    }
    // businessesSorted.push({ disabled: true, Key: "[Archived]", Display: "[Archived Licenses]" });
    for (var item of businessList) {
        if (item.Status === "ARCHIVED")
            businessesSorted.push({
                Key: item.id,
                Display: (
                    <span style={{ color: "red" }}>
                        <em>{item.id + "-" + item.Name}</em>
                    </span>
                ),
                POA: item?.Offer?.Regions?.[0],
                State: GetStateFromPOA({ poa: item?.Offer?.Regions?.[0], offerings }),
            });
    }

    console.log(businessesSorted);
    return businessesSorted;
}

export function GetStateFromPOA({ offerings, poa }) {
    if (
        offerings !== null &&
        poa != null &&
        offerings !== null &&
        offerings[window.brand] !== null &&
        offerings[window.brand]["Regions"] !== null &&
        offerings[window.brand]["Regions"][poa] !== null &&
        offerings[window.brand]["Regions"][poa]?.["region"] !== null &&
        offerings[window.brand]["Regions"][poa]?.["region"]?.["state"] !== null
    ) {
        return offerings[window.brand]["Regions"][poa]?.["region"]?.["state"];
    } else {
        return "";
    }
}

export default SortedBusinessList;
